/**
 * Created by Mark on 24/04/2017.
 */


import React from "react";
import { FormattedMessage } from 'react-intl';
import {Row , Col , Table} from 'react-bootstrap';
import HomeworkWidget from '../../../homework.js'
import CDNImage from '../../../media/image.js';
import MedalGraphic from '../../../media/medal.image.js';

class ScoresPanel extends React.Component {

    constructor(props){
        super();
        this.state = {
            assignment:props.data.assignment,
        }

    }

    componentWillReceiveProps(props){

        console.log(props);
        this.setState({assignment:props.data.assignment})
    }

    renderTableBody(){

        if(!this.state.assignment) return null;

        var body = [];



        for(var idx = 0 ; idx < this.state.assignment.students.length; idx++)
        {
            var student = this.state.assignment.students[idx];

            var getGames = function(){

                var body = [];

                for(var idx = 0; idx < this.state.assignment.tests.length; idx++)
                {
                    var _set = false;

                    for(var jdx = 0; jdx < student.scores.length; jdx++)
                    {
                        if(student.scores[jdx].game_uid == this.state.assignment.tests[idx].uid)
                        {
                            let medal = <MedalGraphic score={student.scores[jdx].medal} />;
                            if(Number(student.scores[jdx].medal) < 50 ) medal =  Number(student.scores[jdx].medal)


                            body.push(

                            <td>
                                {medal}
                            </td>

                            );
                            _set = true;
                        }
                    }

                    if(_set === false)  body.push(<td>-</td>);
                }


                return body;
            }.bind(this)


            body.push(<tr><td>{student.getName()}</td>{getGames()}</tr>);
        }

        return body;
    }

    getGames(){


        var header = [];

        for(var idx = 0; idx < this.state.assignment.tests.length; idx++)
        {
            header.push(<th><CDNImage  size={30} src={"img/gameselectionimages/" + this.state.assignment.tests[idx].picture} /></th>)
        }

        return header;
    }

    render(){

        if(!this.state.assignment) return null;

        console.log(this.state.assignment);
        return (
            <div>
                <div className="pmb-block">
                    <div className="pmbb-body">
                        <Table condensed striped responsive bordered>
                            <thead>
                                <tr>
                                    <th><FormattedMessage id={ 'ui-14' } defaultMessage={ 'Name' } /></th>
                                    {this.getGames()}
                                </tr>
                            </thead>
                            <tbody>
                            {this.renderTableBody()}
                            </tbody>
                        </Table>
                    </div>
                </div>
            </div>
        );
    }
}





export default {
    name: <FormattedMessage id={ 'ui-557' } defaultMessage={ 'Scores' }/>,
    component: ScoresPanel
}


// WEBPACK FOOTER //
// ./src/components/profile/profile-tabs/assignment/scores-panel.js